import { render, staticRenderFns } from "./CreatePortfolioInfoCard.vue?vue&type=template&id=c6bfcba8"
import script from "./CreatePortfolioInfoCard.vue?vue&type=script&lang=js"
export * from "./CreatePortfolioInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports